import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {TerminalsImportRow} from "../interface/terminals-import-row";
import {first, take} from "rxjs/operators";
import {Uuid} from "../interface/response/uuid";
import {ListResponse} from "../interface/response/list-response";

@Injectable({
  providedIn: 'root'
})
export class TerminalsImportRowService {
  public readonly rowListSubject: ReplaySubject<CountedAndPaginated<TerminalsImportRow>>
    = new ReplaySubject<CountedAndPaginated<TerminalsImportRow>>(1);
  public readonly rowListAddSubject: ReplaySubject<CountedAndPaginated<TerminalsImportRow>>
    = new ReplaySubject<CountedAndPaginated<TerminalsImportRow>>(1);
  private readonly rowNotCountedListSubject: ReplaySubject<ListResponse<TerminalsImportRow>>
    = new ReplaySubject<ListResponse<TerminalsImportRow>>(1);


  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  public loadList(page: number, pageSize: number, filters: object): void
  {
    this.httpClient.get(`/rest/crm/terminals-import-row?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe({
        next: (result: CountedAndPaginated<TerminalsImportRow>) => {
          this.rowListSubject.next(result);
        }, error: (error: HttpErrorResponse) => {
          this.rowListSubject.error(error);
        }
      });
  }

  public loadNotCountedList(page: number, pageSize: number, filters: object, observable?: ReplaySubject<ListResponse<TerminalsImportRow>>): void {
    this.httpClient
      .get(`/rest/crm/terminals-import-row?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<TerminalsImportRow>) => {
        if (observable) {
          observable.next(result);
        } else {
          this.rowNotCountedListSubject.next(result);
        }
      });
  }

  public get(uuid: string): Observable<TerminalsImportRow> {
    return this.httpClient.get(`/rest/crm/terminals-import-row/${uuid}`)
      .pipe(first()) as Observable<TerminalsImportRow>;
  }

  downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/terminals-import-row/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public changePartnerFacility(formData: any, uuid: string): Observable<any> {
    return this.httpClient.post(`/rest/crm/terminals-import-row/${uuid}/changePartnerFacility`, formData)
      .pipe(first());
  }

  public statusChange(uuid: string, reason: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/terminals-import-row/${uuid}/changeStatus`, {reason})
      .pipe(first());
  }
}
